import { t } from "@/i18n-js/instance";
import { EditorCollapsable } from "@circle-react-shared/BuilderUI/Editor/EditorCollapsable";
import { DimensionInput } from "@circle-react-shared/BuilderUI/Editor/fields/DimensionInput";

/** @todo Restriction for DimensionInput is on the Image PR. Let's bring that here once merged. */
export const Sizing = () => (
  <EditorCollapsable title={t("builder_ui.prop_type.styles.size")} defaultOpen>
    <div className="flex flex-col px-6 py-4">
      <div className="grid grid-cols-2 gap-4">
        <DimensionInput
          name="styles.sizing.width"
          label={t("builder_ui.prop_type.styles.width")}
          units={["px", "auto", "%"]}
        />
        <DimensionInput
          name="styles.sizing.height"
          label={t("builder_ui.prop_type.styles.height")}
          units={["px", "auto", "%"]}
        />
        <DimensionInput
          name="styles.sizing.minWidth"
          label={t("builder_ui.prop_type.styles.min_width")}
          units={["px", "auto", "%"]}
        />
        <DimensionInput
          name="styles.sizing.minHeight"
          label={t("builder_ui.prop_type.styles.min_height")}
          units={["px", "auto", "%"]}
        />
        <DimensionInput
          name="styles.sizing.maxWidth"
          label={t("builder_ui.prop_type.styles.max_width")}
          units={["px", "auto", "%"]}
        />
        <DimensionInput
          name="styles.sizing.maxHeight"
          label={t("builder_ui.prop_type.styles.max_height")}
          units={["px", "auto", "%"]}
        />
      </div>
    </div>
  </EditorCollapsable>
);
